import styled from 'styled-components/macro';

export default styled.div`
  background-repeat: no-repeat;
  width: 100%;
`;
